export default {"src":"https://images-cdn.curipod.com/d-0d4336dc/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};